import { DcEventConfigSource } from './dc.roster.model';

export const MIN_COLLECTOR_SEARCH_QUERY_LENGTH = 3;

export interface CollectorUser {
  auth0Id: string;
  name: string;
  email?: string;
}

export interface CollectorEligibilityDraftEvent {
  _id?: string;
  code: string;
  collectorAuthId: string | null;
  dcTypeOverride: string | null;
  configSource?: DcEventConfigSource | null;
  status?: string | null;
}

export interface CollectorEligibilityDraftRoster {
  gameId: string;
  dcDate: string;
  dcTime: string;
  dcType: string;
  dcSubtype: string;
  collectionEvents: CollectorEligibilityDraftEvent[];
}

export interface CollectorEligibilityContext {
  gameId: string;
  eventCode: string;
  eventId?: string | null;
  dcDate?: string | null;
  dcTime?: string | null;
  dcType?: string | null;
  dcSubtype?: string | null;
  dcTypeOverride?: string | null;
  gmTeamLeaderAuthId?: string | null;
  currentEventIndex?: number;
  draftRoster?: CollectorEligibilityDraftRoster;
}

export interface CollectorEligibility {
  eligible: boolean;
  ineligibilityReasons: Array<{ code: string; message: string }>;
}

export type EligibleCollectorUser = CollectorUser & CollectorEligibility;
